<template>
  <div>
    <vs-popup :title="$t('CreateNewCity')" :active.sync="showModal">
      <form class="w-full">
        <div>
          <label class="vs-select--label my-1">{{ $t("NameCountry") }}</label>
          <v-select
            label="name"
            :options="allCountries"
            name="country"
            :reduce="(x) => ({ countryId: x.id, countryName: x.name })"
            ref="countryListSelect"
            @input="selectCountry"
            :clearable="false"
            dir="rtl"
          >
          </v-select>
        </div>
        <div class="vx-col w-full mt-3">
          <label class="vs-select--label">{{ $t("Province") }}</label>
          <v-select
            label="name"
            :options="allProvinces"
            name="province"
            :reduce="(x) => ({ provinceId: x.id, provinceName: x.name })"
            v-validate="{ required: 'true' }"
            ref="provinceListSelect"
            v-model="model.parentId"
            :clearable="false"
            dir="rtl"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('province')">{{
            errors.first("province")
          }}</span>
        </div>
        <div>
          <vs-input
            class="inputx mb-3 mt-3"
            v-model="model.name"
            :label="$t('CityName')"
            name="CityName"
            v-validate="{ required: 'true' }"
          />
          <span class="text-danger text-sm" v-show="errors.has('CityName')">{{
            errors.first("CityName")
          }}</span>
        </div>
        <div class="w-full mt-3">
          <vs-input
            class="inputx mb-3"
            v-model="model.priority"
            :label="$t('Priority')"
            name="priority"
            v-validate="{ required: 'true' }"
          />
          <span class="text-danger text-sm" v-show="errors.has('Priority')">{{
            errors.first("Priority")
          }}</span>
        </div>

        <vs-button
          type="filled"
          class="float-right my-4"
          @click.prevent="submitForm"
          :disabled="!model.priority || !model.name || !model.parentId"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    CityName: {
      required: "لطفا نام شهر را وارد نمایید.",
    },
    Priority: {
      required: "لطفا اولویت را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "",
  props: {
    show: { default: false },
  },
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      model: {},
      disabled: true,
    };
  },
  computed: {
    ...mapGetters({
      allProvinces: "country/provincesByIdList",
      allCountries: "country/countryList",
    }),
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  mounted() {
    this.fetchCountry();
  },
  methods: {
    ...mapActions({
      createCity: "country/createCity",
      fetchProvinces: "country/fetchProvinces",
      fetchProvincesById: "country/fetchProvincesById",
      fetchCountry: "country/fetchCountry",
    }),
    selectCountry(country) {
      this.fetchProvincesById(country.countryId);
      if (this.model.parentId) {
        this.model.parentId=null
      }
    },
    submitForm() {
      this.$validator.validateAll().then((r) => {
        if (r) {
          // if (this.model.name != "") {
          this.model.parentId = this.model.parentId.provinceId;
          this.createCity(this.model).then(() => {
            this.disabled = false;
            this.$emit("finish");
            this.model = {};
          });
        } else {
          this.$swal({
            position: "center-center",
            type: "warning",
            text: "خطا در ثبت مقادیر وارده شده",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    },
  },
  watch: {
    model() {
      if (this.model.name && this.model.priority) {
        this.disabled = false;
      }
    },
  },
};
</script>
